<template>
	<div class="fapiao" v-if="showFapiao">
		<div class="imgShade" v-show="imgShow" @click="imgHide">
			<img src="../../static/img/invoice.png" />
		</div>
		<div class="con">
			<p class="con_tit"><span></span><strong>申请会费票据</strong></p>
			<div class="center_con">
				<div class="con_top">
					<!--<h5>关于中国质量协会会员缴纳2019年会费通知的补充说明 </h5>
					<p>各单位会员：<br> 为保证更加规范的财务制度，会员单位在缴纳会费过程中如需向中国质量协会借发票，请依照以下对应格式填写申请，并上传；</p>-->
				</div>

				<div class="con_center">
					<span style="position: absolute;top: -30px;font-size: 16px;font-weight: bold;">已交会费开票申请</span>
					<span class="up_word">申请开票企业名称</span>
					<input class="qiye_name" type="text" v-model="tit" placeholder="请输入申请开票企业名称" />
					<span class="up" @click="post_tit">提交</span>
					<span class="seeStyle" @click='seeStyle'>查看会费票据样式</span>
				</div>
				<div class="con_bot">
					<div class="con_center_bot">
						<span>未交会费预支会费票据</span>
					</div>
					<a class="to_invoice" target="_blank" @click="toInvoice">预支会费票据申请</a>
					<!--<router-link class="to_invoice" target="_blank" to="/invoice">预支会费票据申请</router-link>-->
					<p style="line-height: 45px;font-size: 16px;font-weight: bold;" class="con_bot1_tit">开票记录<span style="font-size: 14px;color: #FF9600;">（电子会费票据将通过Email形式发送，请注意查收。）</span></p>
					<ul class="ul1">
						<li class="w1">事项</li>
						<li class="w2">金额</li>
						<li class="w2">创建时间</li>
						<li class="w3">操作</li>
					</ul>
					<div class="page_con">
						<ul v-for='(item,index) in tableData' class="ul2" :data="allTableData.slice((paginations.page_index-1)*paginations.page_size,paginations.page_index*paginations.page_size)">
							<li class="w1">{{item.year}}</li>
							<li class="w2">{{item.money}}</li>
							<li class="w2">{{item.created_at}}</li>
							<li class="w3">{{item.invoice_status}}</li>
						</ul>
					</div>

					<el-pagination style="width: 45%;height: 35px;border:none;padding: 0;margin: 0 auto;text-align: center;" @size-change="handleSizeChange" @current-change='current' :page-size="paginations.page_size" :current-page="paginations.page_index" :layout="paginations.layout" :total="paginations.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Qs from 'qs'
	export default {
		data() {
			return {
				imgShow:false,
				tit: '',
				tableData: [], //数据
				paginations: {
					page_index: 1, //当前页
					total: 0, //总数
					page_size: 5, //一页显示多少
					layout: 'prev, pager, next'
				},
				allTableData: [], //    每页的数据	
			};
		},
		props: {
			showFapiao: {
				type: Boolean
			}
		},
		created() {
			this.getInfoList();
		},
		mounted() {
			if(sessionStorage.getItem('Token')) {
				var token = sessionStorage.getItem('Token');
			};
		},
		methods: {
			post_tit() {
				if(!this.tit) {
					this.$toast('请输入申请开票企业名称');
					return false;
				}
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data = {
					'ticket': this.tit,
					'access-token': token
				};
				this.$axios({
					method: 'post',
					url: 'invoiceapply/applyinvoice',
					data: Qs.stringify(data)
				}).then(response => {
					this.getInfoList();
					this.$toast(response.data.msg);
				});
			},
			//查看发票样式
			seeStyle(){
				this.imgShow=true;
			},
			imgHide(){
				this.imgShow=false;
			},
			toInvoice(){
				let {href} = this.$router.resolve({path:'/invoice'});
				window.open(href, '_blank');
			},
			//开票记录 分页
			getInfoList() {
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data1 = {
					'access-token': token
				};
				this.$axios({
					method: 'post',
					url: 'invoiceapply/invoiceapplylist',
					data: Qs.stringify(data1)
				}).then(response => {
					if(response.data.state == 1) {
						if(response.data.result.data.length != 0) {
							this.allTableData = response.data.result.data;
							this.setPaginations();
						}
					}

				})
			},
			setPaginations() {
				this.paginations.total = this.allTableData.length; //数据的数量
				this.paginations.page_index = 1; //默认显示第一页
				this.paginations.page_size = 3; //每页显示多少数据
				//显示数据
				this.tableData = this.allTableData.filter((item, index) => {
					return index < this.paginations.page_size;
				})
			},
			handleSizeChange(page_size) {
				this.paginations.page_index = 1; //第一页
				this.paginations.page_size = page_size; //每页先显示多少数据
				this.tableData = this.allTableData.filter((item, index) => {
					return index < page_size
				})
			},
			current(page) {
				// 跳转页数
				//获取当前页
				let index = this.paginations.page_size * (page - 1);
				//获取总数
				let allData = this.paginations.page_size * page;

				let tablist = [];
				for(let i = index; i < allData; i++) {
					if(this.allTableData[i]) {
						tablist.push(this.allTableData[i])
					}
					this.tableData = tablist
				}
			},
		}
	}
</script>
<style scoped>
	.fapiao {
		width: 100%;
		height: auto;
		background: #fff;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #404040;
		text-align: left;
	}
	.imgShade {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .7);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99;
	}
	.imgShade img{
		width:760px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	}
	.con {
		width: 100%;
		height:auto;
		position: relative;
	}
	
	.con_tit {
		padding-left: 18px;
		box-sizing: border-box;
		color: #005EB3;
		font-size: 18px;
		line-height: 45px;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.con_tit span{
		width:4px;
		height:16px;
		background:#4799E4;
		margin-right: 7px;
	}
	
	.center_con {
		text-align: left;
		margin: 0 auto;
		width: 100%;
		height: auto;
		/*box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);*/		
		/*padding: 28px 49px 0 40px;*/
		padding: 0 18px;
		box-sizing: border-box;
	}
	
	.con_top {
		width: 100%;
		height: 30px;
		border-bottom: 1px solid #E0E0E0;
	}
	
	.con_top h5 {
		font-size: 16px;
		color: #404040;
		line-height: 30px;
	}
	
	.con_top p {
		color: #606060;
		font-size: 14px;
		line-height: 30px;
		margin-bottom: 34px;
	}
	
	.con_top div {
		position: relative;
		width: 100%;
		height: 24px;
	}
	
	.con_top div span {
		font-size: 16px;
		color: #000000;
		font-weight: bold;
	}
	
	.con_top div a {
		position: absolute;
		right: 0;
		bottom: -5px;
		color: #0076FF;
	}
	
	.con_center,
	.con_bot {
		position: relative;
		width: 100%;
		height: 144px;
		border-bottom: 1px solid #E0E0E0;
		padding-top: 36px;
	}
	
	.qiye_name {
		width: 280px;
		height: 32px;
		border: 1px solid rgba(207, 212, 214, 1);
		box-sizing: border-box;
		text-indent: 16px;
		margin: 0 20px;
	}
	.up,.seeStyle{
		cursor: pointer;
		color: #fff;
		text-align: center;
		line-height: 30px;
		display: inline-block;
		width:53px;
		height:30px;
		background:rgba(0,118,255,1);
		border-radius:3px;
	}
	.seeStyle{
		width: 135px;
		margin-left: 200px;
	}
	
	.con_bot {
		border-bottom: none;
		height: auto;
		padding:15px 0 0;
	}
	
	.con_center_bot {
		width: 100%;
		height: 30px;
		top: -32px;
		position: absolute;
		bottom: 14px;
	}
	
	.con_center_bot span {
		padding-top: 5px;
		float: left;
		font-size: 16px;
		color: #000000;
		font-weight: bold;
	}
	
	.to_invoice{
		cursor: pointer;
		display: inline-block;
		margin-bottom: 10px;
		padding: 5px 8px;
		border-radius: 3px;
	    background: #0076FF;
	    color: #fff;
	}
	
	.ul1 {
		width: 860px;
		height: 54px;
		background: rgba(250, 250, 250, 1);
		border-radius: 4px 4px 0px 0px;
	}
	
	.ul1 li {
		float: left;
		line-height: 54px;
		text-align: center;
	}
	
	.w1 {
		width: 280px;
	}
	
	.w2 {
		width: 160px;
	}
	
	.w3 {
		width: 260px;
	}
	
	.page_con {
		width: 860px;
		height: 180px;
		margin-bottom: 15px;
	}
	
	.ul2 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 54px;
		border-radius: 4px 4px 0px 0px;
	}
	
	.ul2 li {
		float: left;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/Fapiao.vue